module.exports = __webpack_public_path__ + "static/machine01-sq-768b24c8bcff56c562f922bade6b28e4.png";